var xhr = require('./xhr');
var iframe = require('./iframe');

var transports = [iframe, xhr];

function bestTransport() {
	var i = transports.length;
    while(i-- && !transports[i].supported());
    return transports[i];
}

module.exports = bestTransport;
